<main class="main">

    <div class="container py-5">

        <div class="row justify-content-center">
            <div class="col-lg-10">

                <div class="policy-card p-4 p-md-5">

                    <h2 class="text-center mb-2">Política de Privacidad</h2>
                    <h5 class="text-center text-muted mb-4">GeovyPe - Nomade Apps.</h5>

                    <p class="text-muted text-center">Última actualización: 25 de mayo de 2020</p>

                    <hr>

                    <p>
                        En GeovyPe, operado por Nomade Apps., valoramos y respetamos la privacidad de nuestros usuarios.
                        La presente Política de Privacidad describe cómo recopilamos, utilizamos, almacenamos y
                        protegemos la información personal de los usuarios que utilizan nuestro software y nuestro sitio
                        web.
                    </p>

                    <p>
                        Al utilizar nuestros servicios, aceptas las prácticas descritas en esta Política de Privacidad.
                    </p>

                    <h5 class="section-title">1. Responsable del tratamiento de datos</h5>

                    <p>
                        El responsable del tratamiento de los datos personales es <strong>Nomade Apps.</strong>, empresa
                        desarrolladora del software GeovyPe y operadora del sitio web <strong>geovype.com</strong>.
                    </p>

                    <p>Para cualquier consulta relacionada con privacidad o tratamiento de datos puedes escribir a:</p>

                    <ul>
                        <li><strong>Correo electrónico:</strong> nomadeapplication&#64;gmail.com</li>
                    </ul>

                    <h5 class="section-title">2. Información que recopilamos</h5>

                    <p>Para poder prestar nuestros servicios, podemos recopilar los siguientes tipos de información:</p>

                    <strong>Información de registro</strong>

                    <ul>
                        <li>Nombre o identificador de usuario</li>
                        <li>Correo electrónico</li>
                        <li>Contraseña</li>
                        <li>Confirmación de edad (mayor de 18 años)</li>
                    </ul>

                    <strong>Información del dispositivo</strong>

                    <ul>
                        <li>Identificación del dispositivo</li>
                        <li>Sistema operativo</li>
                        <li>Estado del dispositivo</li>
                        <li>Información técnica necesaria para la conexión con nuestros servidores</li>
                    </ul>

                    <strong>Información de geolocalización</strong>

                    <ul>
                        <li>Ubicación geográfica del dispositivo</li>
                        <li>Historial de ubicaciones</li>
                        <li>Datos de conexión necesarios para transmitir esta información</li>
                    </ul>

                    <p>Esta funcionalidad puede desactivarse desde el Panel de Control.</p>

                    <strong>Información de uso</strong>

                    <p>
                        Podemos recopilar datos anonimizados sobre el uso del sistema con fines estadísticos y de mejora
                        del servicio.
                    </p>

                    <h5 class="section-title">3. Finalidad del tratamiento de los datos</h5>

                    <ul>
                        <li>Proporcionar el servicio de rastreo remoto de dispositivos</li>
                        <li>Permitir el acceso al Panel de Control</li>
                        <li>Administrar cuentas de usuario</li>
                        <li>Mejorar la estabilidad y rendimiento del servicio</li>
                        <li>Garantizar la seguridad de la plataforma</li>
                        <li>Cumplir obligaciones legales aplicables</li>
                    </ul>

                    <p>
                        No utilizamos los datos personales para fines comerciales externos ni publicitarios sin
                        consentimiento del usuario.
                    </p>

                    <h5 class="section-title">4. Base legal para el tratamiento de datos</h5>

                    <ul>
                        <li>La prestación del servicio solicitado por el usuario</li>
                        <li>El consentimiento otorgado al crear una cuenta</li>
                        <li>El cumplimiento de obligaciones legales aplicables</li>
                    </ul>

                    <h5 class="section-title">5. Uso de geolocalización y tracking</h5>

                    <p>
                        La aplicación puede acceder a la ubicación del dispositivo para permitir su rastreo en caso de
                        pérdida o para funciones de administración remota.
                    </p>

                    <p>Con la configuración predeterminada:</p>

                    <ul>
                        <li>La aplicación envía datos cuando detecta cambios de ubicación.</li>
                        <li>El sistema puede almacenar un historial de ubicaciones.</li>
                    </ul>

                    <p>
                        El usuario puede desactivar esta funcionalidad desde el Panel de Control en cualquier momento.
                    </p>

                    <p>
                        Si el usuario desactiva la geolocalización, el sistema solo enviará ubicación cuando el
                        dispositivo sea marcado como <strong>“perdido”</strong>.
                    </p>

                    <h5 class="section-title">6. Protección de la información</h5>

                    <p>
                        Implementamos medidas técnicas y organizativas para proteger los datos personales.
                    </p>

                    <ul>
                        <li>Sistemas de autenticación segura</li>
                        <li>Protección de servidores</li>
                        <li>Encriptación de comunicaciones</li>
                        <li>Control de accesos</li>
                    </ul>

                    <p>
                        El usuario también es responsable de mantener la confidencialidad de su contraseña, token API e
                        identificadores de dispositivo.
                    </p>

                    <h5 class="section-title">7. Acceso a la información</h5>

                    <p>
                        GeovyPe no vende ni comparte información personal con terceros.
                    </p>

                    <p>Solo podremos compartir información cuando:</p>

                    <ul>
                        <li>Sea requerido por ley</li>
                        <li>Exista una orden judicial</li>
                        <li>Sea necesario para proteger la seguridad del sistema</li>
                    </ul>

                    <h5 class="section-title">8. Retención de datos</h5>

                    <p>
                        Los datos se conservarán únicamente durante el tiempo necesario para mantener el servicio
                        activo, cumplir obligaciones legales y garantizar la seguridad del sistema.
                    </p>

                    <p>
                        Si el usuario elimina su cuenta, se iniciará el proceso de eliminación o anonimización de los
                        datos asociados.
                    </p>

                    <h5 class="section-title">9. Derechos del usuario</h5>

                    <ul>
                        <li>Acceso a sus datos</li>
                        <li>Rectificación de información incorrecta</li>
                        <li>Eliminación de datos</li>
                        <li>Portabilidad de información</li>
                        <li>Restricción del tratamiento</li>
                    </ul>

                    <p>
                        Las solicitudes pueden realizarse mediante el correo electrónico indicado en esta política.
                    </p>

                    <h5 class="section-title">10. Eliminación de cuenta</h5>

                    <p>
                        El usuario puede solicitar la eliminación de su cuenta desde el sitio web mediante la opción
                        <strong>“darme de baja”</strong>.
                    </p>

                    <p>
                        La solicitud será evaluada y el usuario recibirá una notificación por correo electrónico
                        confirmando la acción correspondiente.
                    </p>

                    <h5 class="section-title">11. Restricción de edad</h5>

                    <p>
                        Nuestros servicios están disponibles únicamente para personas <strong>mayores de 18
                            años</strong>.
                    </p>

                    <p>
                        Al crear una cuenta el usuario declara cumplir con este requisito.
                    </p>

                    <h5 class="section-title">12. Cambios en la política de privacidad</h5>

                    <p>
                        Nos reservamos el derecho de modificar esta Política de Privacidad en cualquier momento para
                        adaptarla a cambios legales o técnicos.
                    </p>

                    <p>
                        Cuando se realicen modificaciones relevantes se notificará a los usuarios y la versión
                        actualizada será publicada en el sitio web.
                    </p>

                    <p>
                        El uso continuado del servicio después de una actualización se considerará aceptación de la
                        nueva política.
                    </p>

                    <h5 class="section-title">13. Contacto</h5>

                    <p>Si tienes preguntas sobre esta Política de Privacidad puedes contactarnos en:</p>

                    <ul>
                        <li><strong>Correo:</strong> nomadeapplication&#64;gmail.com</li>
                    </ul>

                    <div class="alert alert-secondary mt-4">
                        El uso del servicio GeovyPe implica la aceptación de esta Política de Privacidad.
                    </div>

                </div>
            </div>
        </div>

    </div>